/*
  =============================================================
  LF7 Buyer's Guide — scroll sync script
  Upload to: assets/buyers-guide-scroll-sync.js
  =============================================================
  Keeps the top and bottom horizontal scroll bars of the
  comparison table in sync. Also updates the top scroll bar's
  inner width on window resize so the scroll ratio stays
  accurate when users rotate their phone or resize the window.
  =============================================================
*/

(function () {
  function init() {
    var tableWrap = document.getElementById('lf7TableWrap');
    var scrollTop = document.getElementById('lf7TableScrollTop');
    var scrollTopInner = document.getElementById('lf7TableScrollTopInner');

    // Snippet not rendered on this page — exit quietly.
    if (!tableWrap || !scrollTop || !scrollTopInner) return;

    var table = tableWrap.querySelector('table');
    if (!table) return;

    function syncWidth() {
      scrollTopInner.style.width = table.scrollWidth + 'px';
    }

    syncWidth();
    window.addEventListener('resize', syncWidth);

    var isSyncingTop = false;
    var isSyncingBottom = false;

    scrollTop.addEventListener('scroll', function () {
      if (!isSyncingTop) {
        isSyncingBottom = true;
        tableWrap.scrollLeft = scrollTop.scrollLeft;
      }
      isSyncingTop = false;
    });

    tableWrap.addEventListener('scroll', function () {
      if (!isSyncingBottom) {
        isSyncingTop = true;
        scrollTop.scrollLeft = tableWrap.scrollLeft;
      }
      isSyncingBottom = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
